import React from 'react';

export const SvgClose = () => (
    <svg
        display="none"
        width="0"
        height="0"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <symbol
                id="svg-close"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 50 50"
            >
                <g>
                    <path d="M1.5 50a1.5 1.5 0 0 1-1-2.6l47-47a1.5 1.5 0 0 1 2 2.2l-47 46.8a1.5 1.5 0 0 1-1 .5z" />
                    <path d="M48.4 50a1.5 1.5 0 0 1-1-.4l-47-47A1.5 1.5 0 0 1 2.8.3l46.7 47a1.5 1.5 0 0 1-1 2.6z" />
                </g>
            </symbol>
        </defs>
    </svg>
);

export const SvgDestinationUrgency = () => (
    <svg
        display="none"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <symbol
                id="svg-destination-urgency"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 36 32"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g>
                        <ellipse
                            id="Oval-3"
                            fill="#228AE6"
                            opacity="0.200000003"
                            cx="17"
                            cy="32"
                            rx="17"
                            ry="2"
                        />
                        <path
                            d="M29.2556391,18 C29.2556391,17.5889008 29.5889008,17.2556391 30,17.2556391 C30.4110992,17.2556391 30.7443609,17.5889008 30.7443609,18 L30.7443609,29 C30.7443609,29.9633839 29.9633839,30.7443609 29,30.7443609 L20,30.7443609 C19.5889008,30.7443609 19.2556391,30.4110992 19.2556391,30 C19.2556391,29.5889008 19.5889008,29.2556391 20,29.2556391 L29,29.2556391 C29.1411856,29.2556391 29.2556391,29.1411856 29.2556391,29 L29.2556391,18 Z M11,29.2556391 C11.4110992,29.2556391 11.7443609,29.5889008 11.7443609,30 C11.7443609,30.4110992 11.4110992,30.7443609 11,30.7443609 L5,30.7443609 C4.03661608,30.7443609 3.2556391,29.9633839 3.2556391,29 L3.2556391,14.3909838 C3.2556391,13.9524689 3.42080165,13.5300408 3.7182376,13.2078185 L15.453041,0.495114811 C15.7318814,0.193037721 16.2028081,0.174200655 16.5048852,0.453041045 C16.8069623,0.731881435 16.8257993,1.2028081 16.546959,1.50488519 L4.81215551,14.2175889 C4.76856576,14.2648112 4.7443609,14.3267187 4.7443609,14.3909838 L4.7443609,29 C4.7443609,29.1411856 4.85881442,29.2556391 5,29.2556391 L11,29.2556391 Z M14.7443609,30 C14.7443609,30.4110992 14.4110992,30.7443609 14,30.7443609 C13.5889008,30.7443609 13.2556391,30.4110992 13.2556391,30 L13.2556391,22 C13.2556391,21.0366161 14.0366161,20.2556391 15,20.2556391 L19,20.2556391 C19.9633839,20.2556391 20.7443609,21.0366161 20.7443609,22 L20.7443609,30 C20.7443609,30.4110992 20.4110992,30.7443609 20,30.7443609 C19.5889008,30.7443609 19.2556391,30.4110992 19.2556391,30 L19.2556391,22 C19.2556391,21.8588144 19.1411856,21.7443609 19,21.7443609 L15,21.7443609 C14.8588144,21.7443609 14.7443609,21.8588144 14.7443609,22 L14.7443609,30 Z"
                            id="Combined-Shape"
                            fill="#323F4D"
                            fillRule="nonzero"
                        />
                        <path
                            d="M22.7179164,1.21300399 C21.0722538,2.39233448 20,4.3209481 20,6.5 C20,10.0898509 22.9101491,13 26.5,13 C28.6790519,13 30.6076655,11.9277462 31.786996,10.2820836 C30.9871778,13.5639255 28.0280768,16 24.5,16 C20.3578644,16 17,12.6421356 17,8.5 C17,4.97192324 19.4360745,2.01282217 22.7179164,1.21300399 Z"
                            id="Combined-Shape"
                            fill="#228AE6"
                            opacity="0.200000003"
                        />
                        <path
                            d="M24.5,16.7443609 C19.9467652,16.7443609 16.2556391,13.0532348 16.2556391,8.5 C16.2556391,3.9467652 19.9467652,0.255639098 24.5,0.255639098 C29.0532348,0.255639098 32.7443609,3.9467652 32.7443609,8.5 C32.7443609,13.0532348 29.0532348,16.7443609 24.5,16.7443609 Z M24.5,15.2556391 C28.2310364,15.2556391 31.2556391,12.2310364 31.2556391,8.5 C31.2556391,4.76896355 28.2310364,1.7443609 24.5,1.7443609 C20.7689636,1.7443609 17.7443609,4.76896355 17.7443609,8.5 C17.7443609,12.2310364 20.7689636,15.2556391 24.5,15.2556391 Z"
                            id="Oval"
                            fill="#323F4D"
                            fillRule="nonzero"
                        />
                        <path
                            d="M29.4736574,14.5263426 C29.1829663,14.2356516 29.1829663,13.7643484 29.4736574,13.4736574 C29.7643484,13.1829663 30.2356516,13.1829663 30.5263426,13.4736574 L35.5263426,18.4736574 C35.8170337,18.7643484 35.8170337,19.2356516 35.5263426,19.5263426 C35.2356516,19.8170337 34.7643484,19.8170337 34.4736574,19.5263426 L29.4736574,14.5263426 Z"
                            id="Line"
                            fill="#323F4D"
                            fillRule="nonzero"
                        />
                    </g>
                </g>
            </symbol>
        </defs>
    </svg>
);
